// extracted by mini-css-extract-plugin
module.exports = {"logoMicrosoft":"LogoMicrosoft_logoMicrosoft__3MrzT"};